export let HistorialComponent = {
    selector: 'historialList',
    template: require('./historial.html'),
    bindings: {
        historial: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(HistorialService) {
            Object.assign(this, {HistorialService});
        }

        limit = 20;
        loadMoreVisible = true;

        cargarMas() {
            this.limit += 20;
            this.HistorialService.getHistorial(this.limit)
                .then(historial => {
                    this.historial = historial.data;
                    if (historial.data.length < this.limit)
                        this.loadMoreVisible = false;
                });
        }

    }
};



// WEBPACK FOOTER //
// ./client/app/historial-route/historial.component.js